
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/missing-queries",
      function () {
        return require("private-next-pages/admin/missing-queries.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/missing-queries"])
      });
    }
  